import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MdsComponentsComponent } from './shared/components/mds-components/mds-components.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MdsComponentsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
}
